/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class PDFPreviewController {
    // @ngInject
    constructor($scope, $state, $rootScope, $sce, $window, $timeout, localStorageService, filePreviewAvailable, PDFViewerService, authService, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let plan = localStorageService.get("currentPlan")
        let authoring = localStorageService.get("authoringData")
        let resourceId = $state.params.resourceId;
        let themeId = plan.theme_id;
        let curriculumId = authoring.curriculum_id;
        let sessionId = authoring.session_id;
        let classId = authoring.class_id;
        let batchId = authoring.batch_id;
        let subjectId = authoring.subject_id;


        /********************************** PDF ANNOTATION *****************************************/
        let element = document.getElementById("pdf-preview-div")
        let canvas = document.getElementById('canvas');
        let canvasTemp = document.getElementById("canvasTemp");

        if (canvas) {
            var ctx = canvas.getContext('2d');
            var ctxTemp = canvasTemp ? canvasTemp.getContext("2d") : null;
        }

        $scope.normalHeight = $window.innerHeight

        var x = $("#canvas").offset().left;
        var y = $("#canvas").offset().top;
        let top = parseInt(y)
        let left = parseInt(x)

        $("#canvasTemp").css({
            'top': -2000,
            'left': left,
            'z-index': 1
        });

        let drawing = false;
        let lastX;
        let lastY;
        ctx.lineJoin = ctx.lineCap = 'round';
        let points = [],
            fhPoints = [],
            redo_list = [];

        let undo = function() {
            restoreState(canvas, ctx, points, redo_list, false);
        };
        let redo = function() {
            restoreState(canvas, ctx, points, redo_list, true);
        };
        let restoreState = function(canvas, ctx, pop, push, isRedo) {
            if (isRedo) {
                if (push.length) {
                    var restore_state = push.pop();
                    restore_state['undo'] = false
                    points.push(restore_state)
                    resetDrawing()
                }
            } else {
                if (pop.length) {
                    var restore_state = pop.pop();
                    restore_state['undo'] = true
                    redo_list.push(restore_state)
                    resetDrawing()
                }
            }
        };

        let getPdfHeight = function() {
            let element = document.getElementById("pdf-preview-div")
            let pdfHolder = element.getElementsByTagName('pdfviewer')[0];
            var ratio = backingScale()
            var w = pdfHolder.firstChild.clientWidth
            var h = pdfHolder.firstChild.clientHeight
            $scope.windowWidth = Math.floor(w * ratio);
            $scope.windowHeight = Math.floor(h * ratio);
            $scope.windowInnerWidth = Math.floor(w) + 'px';
            $scope.windowInnerHeight = Math.floor(h) + 'px';
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
            resetDrawing()
            canvas.style.pointerEvents = 'auto|none';
        };
        let backingScale = function() {
            var dpr = window.devicePixelRatio || 1;
            var bsr = ctx.webkitBackingStorePixelRatio ||
                ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
                ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

            return dpr / bsr;
        };
        let clearPageAnnotation = function() {
            points = _.filter(points, (each) => {
                return each.page !== $scope.pageNumber
            })
            resetDrawing();
        };

        let updateNewDrawing = function(pts) {
            points = _.filter(pts, (each) => {
                return !each.undo
            })
            redo_list = _.filter(pts, (each) => {
                return each.undo
            })
            resetDrawing()
        }

        let resetDrawing = function() {
            ctx.clearRect(0, 0, $scope.windowWidth, $scope.windowHeight);
            let imgs = [];
            let imgIndex = 0;
            let pointDetails = []

            $scope.pointData = points

            //Load previously Saved Annotation
            let pointFreeDetails = _.filter(points, function(p_data) {
                return p_data.page === $scope.pageNumber
            })

            //Filter undo annotations
            if (redo_list != undefined && redo_list.length > 0) {

                let redoIds = _.compact(_.pluck(redo_list, '_id'))
                let pointIds = _.compact(_.pluck(pointFreeDetails, '_id'))
                let pointArray = _.difference(pointIds, redoIds);
                _.each(pointArray, function(pts) {
                    let pointObj = _.find(pointFreeDetails, function(obj) {
                        return obj._id === pts && obj.undo != true
                    })
                    if (pointObj != undefined) {
                        pointDetails.push(pointObj)
                    }
                })
            } else {
                pointDetails = pointFreeDetails
            }

            _.each(pointDetails, function(each_point) {
                ctx.beginPath()
                ctx.lineJoin = ctx.lineCap = 'round';
                if (each_point.tool_name == 'Pencil') {

                    let scale = $scope.windowWidth / each_point.width
                    ctx.lineWidth = each_point.thickness;
                    ctx.strokeStyle = '#000000'
                    if (each_point.draw_points != undefined && each_point.draw_points.length > 0) {
                        ctx.moveTo(each_point.draw_points[0].x * scale, each_point.draw_points[0].y * scale);
                        for (var j = 1; j < each_point.draw_points.length; j++) {
                            ctx.lineTo(each_point.draw_points[j].x * scale, each_point.draw_points[j].y * scale);
                        }
                    }
                    ctx.stroke();
                } else if (each_point.tool_name == 'Line') {
                    let scale = $scope.windowWidth / each_point.width
                    ctx.lineWidth = each_point.thickness;
                    ctx.strokeStyle = '#000000'
                    ctx.moveTo(each_point.x1 * scale, each_point.y1 * scale);
                    ctx.lineTo(each_point.x2 * scale, each_point.y2 * scale);
                    ctx.stroke();
                } else if (each_point.tool_name == 'Rectangle') {
                    let scale = $scope.windowWidth / each_point.width
                    ctx.lineWidth = each_point.thickness;
                    ctx.strokeStyle = 'rgba(255, 255, 0, 0.4)'
                    ctx.rect(each_point.x * scale, each_point.y * scale, each_point.w * scale, each_point.h * scale);
                    ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                    ctx.fill();
                    ctx.stroke();

                } else if (each_point.tool_name == 'Marker') {
                    let scale = $scope.windowWidth / each_point.width
                    ctx.lineWidth = each_point.thickness;
                    ctx.strokeStyle = 'rgba(255, 255, 0, 0.4)'
                    if (each_point.draw_points != undefined && each_point.draw_points.length > 0) {
                        ctx.moveTo(each_point.draw_points[0].x * scale, each_point.draw_points[0].y * scale);
                        for (var j = 1; j < each_point.draw_points.length; j++) {
                            ctx.lineTo(each_point.draw_points[j].x * scale, each_point.draw_points[j].y * scale);
                        }
                        ctx.stroke();
                    }

                }
            })
        };
        let currentX, currentY
        canvas.onmouseover = function(event) {
            if (event.offsetX !== undefined) {
                currentX = event.offsetX;
                currentY = event.offsetY;
            } else {
                currentX = event.layerX - event.currentTarget.offsetLeft;
                currentY = event.layerY - event.currentTarget.offsetTop;
            }
        }
        canvas.onmouseout = function(event) {
            if (event.offsetX !== undefined) {
                currentX = event.offsetX;
                currentY = event.offsetY;
            } else {
                currentX = event.layerX - event.currentTarget.offsetLeft;
                currentY = event.layerY - event.currentTarget.offsetTop;
            }
        }
        canvas.addEventListener('touchstart', onTouchStart, false);
        canvas.addEventListener('touchmove', onTouchMove, false);
        canvas.addEventListener('touchend', onTouchEnd, false);
        canvasTemp.addEventListener('touchstart', onTouchStart, false);
        canvasTemp.addEventListener('touchmove', onTouchMove, false);
        canvasTemp.addEventListener('touchend', onTouchEnd, false);
        canvas.addEventListener('mousedown', onMouseStart, false);
        canvas.addEventListener('mousemove', onMouseMove, false);
        canvas.addEventListener('mouseup', onMouseEnd, false);
        canvasTemp.addEventListener('mousedown', onMouseStart, false);
        canvasTemp.addEventListener('mousemove', onMouseMove, false);
        canvasTemp.addEventListener('mouseup', onMouseEnd, false);
        // document.addEventListener('load', resize, false);
        // document.addEventListener('resize', resize, false);

        // function resize() {

        //     /* // Our canvas must cover full height of screen
        //      // regardless of the resolution
        //      var height = window.innerHeight;
        //      // So we need to calculate the proper scaled width
        //      // that should work well with every resolution
        //      var ratio = canvas.width / canvas.height;
        //      var width = height * ratio;

        //      canvas.style.width = width + 'px';
        //      canvas.style.height = height + 'px';*/


        // }

        // Get the position of a touch relative to the canvas
        function getTouchPos(canvasDom, touchEvent) {
            var rect = canvasDom.getBoundingClientRect();
            return {
                x: touchEvent.touches[0].clientX - rect.left,
                y: touchEvent.touches[0].clientY - rect.top
            };
        }
        // Get the position of the mouse relative to the canvas
        function getMousePos(canvasDom, mouseEvent) {
            var rect = canvasDom.getBoundingClientRect();
            return {
                x: mouseEvent.clientX - rect.left,
                y: mouseEvent.clientY - rect.top
            };
        }

        document.body.addEventListener("touchstart", function(e) {
            if (e.target == canvas && drawing) {
                e.preventDefault();
            }
        }, false);
        document.body.addEventListener("touchend", function(e) {
            if (e.target == canvas && drawing) {
                e.preventDefault();
            }
        }, false);
        document.body.addEventListener("touchmove", function(e) {
            if (e.target == canvas && drawing) {
                e.preventDefault();
            }
        }, false);

        function onTouchStart(event) {
            mousePos = getTouchPos(canvas, event);
            var touch = event.touches[0];
            var mouseEvent = new MouseEvent("mousedown", {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
        }

        function onTouchMove(event) {
            var touch = event.touches[0];
            var mouseEvent = new MouseEvent("mousemove", {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
        }

        function onTouchEnd(event) {
            var mouseEvent = new MouseEvent("mouseup", {});
            canvas.dispatchEvent(mouseEvent);
        }

        function onMouseStart(event) {
            lastX = lastY = ''
            let lastPos = getMousePos(canvas, event);
            if (event.offsetX !== undefined) {
                lastX = event.offsetX;
                lastY = event.offsetY;
            } else {
                lastX = lastPos.x; //event.layerX - event.currentTarget.offsetLeft;
                lastY = lastPos.y; //event.layerY - event.currentTarget.offsetTop;
            }

            // begins new line
            ctx.beginPath();
            fhPoints = []
            let isNotesOpen = false

            if (!isNotesOpen) {
                if ($scope.tool == 'Pencil') {
                    ctx.lineWidth = $scope.lineThickness;
                    ctx.strokeStyle = '#000000'
                    ctx.fillStyle = '#000000';
                    ctx.moveTo(lastX, lastY);
                    fhPoints.push({
                        x: lastX,
                        y: lastY
                    });
                    drawing = true;
                } else if ($scope.tool == 'Line') {
                    ctx.lineWidth = $scope.lineThickness;
                    ctx.strokeStyle = '#000000'
                    ctx.fillStyle = '#000000';

                    var x = $("#canvas").offset().left;
                    var y = $("#canvas").offset().top;
                    let top = parseInt(y)
                    let left = parseInt(x) + 'px'
                    $("#canvasTemp").css({
                        'top': top,
                        'left': left,
                        'z-index': 2
                    });
                    $("#canvas").css({
                        'z-index': 1
                    });
                    ctxTemp.lineWidth = $scope.lineThickness;
                    ctxTemp.strokeStyle = '#000000'
                    ctxTemp.fillStyle = '#000000';
                    ctxTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);
                    drawing = true;
                } else if ($scope.tool == 'Marker') {
                    ctx.lineWidth = $scope.lineThickness;
                    ctx.strokeStyle = 'rgba(255, 255, 0, 0.1)'
                    ctx.moveTo(lastX, lastY);
                    fhPoints.push({
                        x: lastX,
                        y: lastY
                    });
                    drawing = true;
                } else if ($scope.tool == 'Rectangle') {
                    ctx.lineWidth = $scope.lineThickness;
                    ctx.strokeStyle = 'rgba(255, 255, 0, 0.4)'
                    ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                    drawing = true;
                } else if ($scope.tool == 'Notes') {
                    $scope.takeNotes()
                    drawing = true;
                }

            }
        }

        function onMouseMove(event) {
            if (drawing) {
                // get current mouse position
                let currentPos = getMousePos(canvas, event);
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = currentPos.x; //event.layerX - event.currentTarget.offsetLeft;
                    currentY = currentPos.y; //event.layerY - event.currentTarget.offsetTop;
                }

                if ($scope.tool == 'Pencil') {
                    ctx.lineTo(currentX, currentY);
                    fhPoints.push({
                        x: currentX,
                        y: currentY
                    });
                    ctx.stroke();
                } else if ($scope.tool == 'Line') {

                    ctxTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);
                    ctxTemp.beginPath();
                    ctxTemp.moveTo(lastX, lastY);
                    ctxTemp.lineTo(currentX, currentY);
                    ctxTemp.stroke();
                } else if ($scope.tool == 'Rectangle') {} else if ($scope.tool == 'Marker') {
                    ctx.lineTo(currentX, currentY);
                    fhPoints.push({
                        x: currentX,
                        y: currentY
                    });
                    ctx.stroke();
                }

            }
        }

        function onMouseEnd(event) {
            // stop drawing
            let valueObj = {}
            drawing = false;
            if ($scope.tool == 'Line') {


                var x = $("#canvas").offset().left;
                let left = parseInt(x)
                $("#canvasTemp").css({
                    'top': -2000,
                    'left': left,
                    'z-index': 1
                });
                $("#canvas").css({
                    'z-index': 2
                });
                ctxTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);
                ctx.beginPath();
                ctx.moveTo(lastX, lastY);
                ctx.lineTo(currentX, currentY);
                ctx.stroke();
                valueObj = {
                    page: $scope.pageNumber,
                    tool_name: $scope.tool,
                    x1: lastX,
                    y1: lastY,
                    x2: currentX,
                    y2: currentY,
                    undo: false,
                    thickness: $scope.lineThickness,
                    theme: themeId,
                    user_id: userId,
                    subject_id: subjectId,
                    class_id: classId,
                    curriculum: curriculumId,
                    session_id: sessionId,
                    batch_id: batchId,
                    width: $scope.windowWidth,
                    height: $scope.windowHeight,
                    pdf_url: $scope.resource.url,
                    resource_id: resourceId
                }
                updateValues(valueObj)
            } else if ($scope.tool == 'Pencil') {
                valueObj = {
                    page: $scope.pageNumber,
                    tool_name: $scope.tool,
                    draw_points: fhPoints,
                    thickness: $scope.lineThickness,
                    theme: themeId,
                    user_id: userId,
                    subject_id: subjectId,
                    class_id: classId,
                    curriculum: curriculumId,
                    session_id: sessionId,
                    batch_id: batchId,
                    width: $scope.windowWidth,
                    height: $scope.windowHeight,
                    undo: false,
                    pdf_url: $scope.resource.url,
                    resource_id: resourceId
                }
                updateValues(valueObj)

            } else if ($scope.tool == 'Rectangle') {
                ctx.rect(lastX, lastY, currentX - lastX, currentY - lastY);
                ctx.fill();
                ctx.stroke();

                valueObj = {
                    page: $scope.pageNumber,
                    tool_name: $scope.tool,
                    x: lastX,
                    y: lastY,
                    w: currentX - lastX,
                    h: currentY - lastY,
                    thickness: $scope.lineThickness,
                    theme: themeId,
                    user_id: userId,
                    subject_id: subjectId,
                    class_id: classId,
                    curriculum: curriculumId,
                    session_id: sessionId,
                    batch_id: batchId,
                    width: $scope.windowWidth,
                    height: $scope.windowHeight,
                    undo: false,
                    pdf_url: $scope.resource.url,
                    resource_id: resourceId
                }
                updateValues(valueObj)
            } else if ($scope.tool == 'Marker') {

                valueObj = {
                    page: $scope.pageNumber,
                    tool_name: $scope.tool,
                    draw_points: fhPoints,
                    thickness: $scope.lineThickness,
                    theme: themeId,
                    user_id: userId,
                    subject_id: subjectId,
                    class_id: classId,
                    session_id: sessionId,
                    batch_id: batchId,
                    curriculum: curriculumId,
                    width: $scope.windowWidth,
                    height: $scope.windowHeight,
                    undo: false,
                    pdf_url: $scope.resource.url,
                    resource_id: resourceId
                }
                updateValues(valueObj)
            }
        }

        let changePDFPage = function() {
            let list = _.filter(points, (each) => {
                return each.page === $scope.pageNumber
            })
            if (redo_list.length > 0) {
                let redoList = _.filter(redo_list, (each) => {
                    return each.page === $scope.pageNumber
                })
                list.push(...redoList)
            }
            updatePageAnnotations(list)
        }

        let updateValues = function(pointes) {
            authService.callAPI(TPWIZARDCONSTANT.API_ADD_PDF_ANNOTATION, "POST", pointes, (response) => {
                if (response.result.data) {
                    points.push(response.result.data)
                }
            })
        }

        let fetchValues = function() {
            let detailObj = {
                "session_id": sessionId,
                "curriculum_id": curriculumId,
                "class_id": classId,
                "batch_id": batchId,
                "subject_id": subjectId,
                "resource_id": resourceId,
                "page_number": $scope.pageNumber,
                "user_id": userId
            }
            authService.callAPI(TPWIZARDCONSTANT.API_FETCH_ANNOTATION, "POST", detailObj, (response) => {
                updateNewDrawing(response.result.data)
            })

        }

        let removeAnnotateValues = () => {
            let detailObj = {
                "session_id": sessionId,
                "curriculum_id": curriculumId,
                "class_id": classId,
                "batch_id": batchId,
                "subject_id": subjectId,
                "resource_id": resourceId,
                "page_number": $scope.pageNumber,
                "user_id": userId
            }
            authService.callAPI(TPWIZARDCONSTANT.API_REMOVE_ANNOTATION, "POST", detailObj, (response) => {})
        }

        let updatePageAnnotations = function(list) {
            let detailObj = {
                "session_id": sessionId,
                "curriculum_id": curriculumId,
                "class_id": classId,
                "batch_id": batchId,
                "subject_id": subjectId,
                "resource_id": resourceId,
                "page_number": $scope.pageNumber,
                "user_id": userId,
                "list": list
            }
            authService.callAPI(TPWIZARDCONSTANT.API_UPDATE_PAGE_ANNOTATION, "POST", detailObj, (response) => {})
        }

        let updateAllAnnotations = function(list) {
            let detailObj = {
                "session_id": sessionId,
                "curriculum_id": curriculumId,
                "class_id": classId,
                "batch_id": batchId,
                "subject_id": subjectId,
                "resource_id": resourceId,
                "page_number": $scope.pageNumber,
                "user_id": userId,
                "list": list
            }
            authService.callAPI(TPWIZARDCONSTANT.API_UPDATE_ALL_PAGE_ANNOTATION, "POST", detailObj, (response) => {})
        }

        // Get a regular interval for drawing to the screen
        window.requestAnimFrame = (function(callback) {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimaitonFrame ||
                function(callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
        })();
        /********************************** PDF ANNOTATION *****************************************/

        $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
            if (points && redo_list) {
                if (points.length > 0 || redo_list.length > 0)
                    updateAllAnnotations(points)
            }
        })

        //Hide tool bar
        $scope.hideToolbar = true;

        //Pdf js workerjs url
        // PDFJS.workerSrc = '../../../../../../libs/pdf.worker.js';

        //Start page number
        $scope.pageNumber = 1

        //Total pages
        $scope.totalPageNumber = 1

        //Page start and end
        let pageStart, pageEnd

        //PDF annotation tools
        $scope.tools = [{
            tool: 'Pencil',
            expanded: false,
            icon: '../../../../../../img/pdf-viewer/ic_create.png'
        }, {
            tool: 'Line',
            expanded: false,
            icon: '../../../../../../img/pdf-viewer/ic_line.png'
        }, {
            tool: 'Marker',
            expanded: false,
            icon: '../../../../../../img/pdf-viewer/ic_brush.png'
        }]


        /*
         * Function To init pdf
         * @developer - Arul Mozhi J
         */
        $scope.initpdf = function() {
            if ($scope.pdfLinks === undefined) {
                return
            }
            $scope.isPDFExist = true
            $scope.showLoadingFirst = true
            $scope.instance = PDFViewerService.Instance("pdf_viewer");
            $scope.pageStart = 1
        }

        /*
         * Function To go to next page
         * @developer - Arul Mozhi J
         */
        $scope.nextPage = function() {
            PDFViewerService.nextPage();
            if (PDFViewerService.getTotalPageNumber() != $scope.pageNumber) {
                $scope.loading = true
                $scope.showHide = false
            }
            if ($scope.pageNumber < $scope.pageEnd) {
                changePDFPage();
                $scope.pageNumber++;
            }
        };

        /*
         * Function To go to prev page
         * @developer - Arul Mozhi J
         */
        $scope.prevPage = function() {
            PDFViewerService.prevPage();
            if ($scope.pageNumber > 1) {
                $scope.loading = true
                $scope.showHide = false
                changePDFPage();
                $scope.pageNumber--;
            }
        };

        /*
         * Function To load page
         * @developer - Arul Mozhi J
         */
        $scope.pageLoaded = function(curPage, maxPage, totalPages) {
            if ($scope.instance != undefined) {
                $scope.instance = PDFViewerService.Instance("pdf_viewer");
            }
            $scope.pageNumber = PDFViewerService.getPageNumber()
            $scope.totalPageNumber = PDFViewerService.getTotalPageNumber()
            if ($scope.pdfLinks != undefined && $scope.pdfLinks.type === 'single') {
                $scope.pageStart = parseInt(pageStart);
                $scope.pageEnd = parseInt(pageEnd);
            } else {
                $scope.pageStart = 1
                $scope.pageEnd = parseInt($scope.totalPageNumber);
            }
            $timeout(getPdfHeight(), 100)
            $scope.loading = false
            $scope.hideToolbar = false;
            $scope.showHide = true;
            fetchValues()
        };

        /*
         * Function To calculate progress
         * @developer - Arul Mozhi J
         */
        $scope.loadProgress = function(loaded, total, state) {
            if (_.isObject(state)) {
                $scope.isPDFExist = false
            } else {
                if (state === "finished") {
                    $scope.isPDFExist = true
                    $scope.showLoadingFirst = false
                }
            }
        };


        $scope.setTool = function(toolName, data) {
            for (var i in $scope.tools) {
                if ($scope.tools[i] != data) {
                    $scope.tools[i].expanded = false;
                }
            }
            data.expanded = !data.expanded;
            if (data.expanded) {
                $scope.tool = toolName
            } else {
                $scope.tool = ''
            }
        }

        $scope.undoDrawing = function() {
            undo();
        }

        $scope.redoDrawing = function() {
            redo();
        }
        $scope.clearPage = function() {
            clearPageAnnotation()
            removeAnnotateValues()
        };

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })

                if ($scope.userPrev.preview && $scope.userPrev.preview.read && ($scope.userPrev.uploadPdf == undefined || ($scope.userPrev.uploadPdf && !$scope.userPrev.uploadPdf.create)) && ($scope.userPrev.approvePdf == undefined || ($scope.userPrev.approvePdf && !$scope.userPrev.approvePdf.create))) {
                    try {
                        var data = {
                            resource: {
                                type: $scope.resource.type,
                                subject_id: authoring.subject_id,
                                class_id: authoring.class_id,
                                curriculum_id: authoring.curriculum_id,
                                batch_id: authoring.batch_id,
                                session_id: authoring.session_id,
                                school_id: authoring.school_id,
                                theme_id: plan.theme_id,
                                plan_id: planId,
                                progress_data: {
                                    _id: resourceId,
                                    title: $scope.resource.title
                                }
                            },
                            user_id: userId
                        }
                        authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, () => {})
                    } catch (ex) {}

                }
                if ($scope.resource) {
                    if ($scope.resource.url) {
                        $scope.isAvailable = true
                        filePreviewAvailable.filePreviewUrl('local', $scope.resource.url, function(response) {
                            if (response.fileAvaliable) {
                                $scope.fileAvaliable = response.fileAvaliable
                                $scope.src = $sce.trustAsResourceUrl(response.fileUrl)
                                _.defer(() => {
                                    $scope.$apply();
                                });
                            }
                        })
                    }
                }
            }
        }
        /*UserPrivilages.getUserPrivilageInitialSetting(function() {
            let userAccess = UserPrivilages.getFeatures('pdf');
            $scope.userPrev = {};
            if (userAccess.length > 0) {
                _.each(userAccess, function(obj) {
                    let user_access = {};
                    _.each(obj.privilege, function(privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    $scope.userPrev[obj.feature_id] = user_access;
                })
            }
            loadTemplate()
        })*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "pdf"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }
    };
}

export default PDFPreviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/pdfPreview.js